var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.321 15.2437H10.3893C10.0149 15.2437 9.66961 15.4488 9.48566 15.7804L4.13541 25.4261C3.7452 26.1296 4.24493 27 5.03905 27H30.961C31.7537 27 32.2536 26.1323 31.8661 25.4288L26.5527 15.7831C26.3692 15.45 26.023 15.2437 25.6476 15.2437L23.6372 15.2437L22.743 16.7915H25.3638L30.1347 25.4522H5.86815L10.6721 16.7915H13.2023L12.3266 15.2517C12.3247 15.249 12.3229 15.2463 12.321 15.2437Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 5C14.7197 5 12.0312 7.72637 12.0312 11.0539C12.0312 12.3432 12.4361 13.5415 13.1213 14.5264L17.2716 21.8245C17.8529 22.5969 18.2393 22.4502 18.7226 21.7837L23.3005 13.8597C23.3928 13.6895 23.4654 13.5083 23.5286 13.3232C23.8191 12.6031 23.9685 11.8323 23.9684 11.0539C23.9686 7.72637 21.281 5 18.0001 5ZM18.0001 7.83656C19.7669 7.83656 21.1716 9.26219 21.1716 11.0539C21.1716 12.8456 19.7669 14.2707 18.0001 14.2707C16.2336 14.2707 14.8282 12.8459 14.8282 11.0539C14.8282 9.26219 16.2336 7.83677 18.0001 7.83677V7.83656Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map_icon.84d213a1cf9aedf645f5303380b13618.svg";
export { ForwardRef as ReactComponent };